import { jwtDecode } from "jwt-decode";
import { enterContest } from "../../../../utils/api";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export const handleSubmit = async (lineup, contest, handleSuccessCallback) => {
  // 1. Check for login token
  const token = localStorage.getItem("accessToken");
  if (!token) {
    // Return error object, don't alert here
    return { success: false, message: "You must be logged in to submit a team." };
  }

  // 2. Prepare lineup data for the backend
  // Backend needs `team` (object with captain/flexPlayers names) and `teamSalary`
  const captainSlot = lineup.find((slot) => slot.position === 'Cpt');
  const flexSlots = lineup.filter((slot) => slot.position === 'Flex');

  // Basic validation: Ensure all slots are filled (backend will re-validate)
  if (!captainSlot?.player || flexSlots.some(slot => !slot.player)) {
      // Return error object, don't alert here
      return { success: false, message: "Please complete your lineup before submitting." };
  }
  
  const teamPayload = {
      captain: captainSlot.player.name,
      flexPlayers: flexSlots.map(slot => slot.player.name)
  };

  const teamSalary = lineup.reduce((total, slot) => total + (slot.player?.salary || 0), 0);

  // Combine team and salary into a single payload object
  const payload = {
    team: teamPayload,
    teamSalary: teamSalary,
  };

  // 3. Call the secure API endpoint via api.js function
  try {
    const result = await enterContest(contest._id, payload);
    // console.log("Contest entry successful:", result);
    
    // Execute the success callback passed from DraftModule (for UI updates)
    if (handleSuccessCallback && typeof handleSuccessCallback === 'function') {
        handleSuccessCallback();
    }

    // Reload page after success logic
    // Consider if reload is still the best UX, maybe update state instead
    setTimeout(() => {
        window.location.reload();
    }, 1500); // Keep a small delay for UI feedback
    
    return { success: true, data: result };

  } catch (error) {
    // console.error("Error entering contest:", error);
    // Return error object with message, don't alert here
    return { success: false, message: error.message || "Contest entry failed. Please try again." };
  }
};
